import { z } from "zod";

export const ToolboxTalkAcknowledgementStatusSchema = z.enum([
  "PENDING",
  "ACKNOWLEDGED",
  "SUPERSEDED",
]);

export const ToolboxTalkAcknowledgementSchema = z.object({
  id: z.string(),
  documentId: z.string(),
  documentVersionId: z.string().nullable().optional(),
  portalUserId: z.string(),
  status: ToolboxTalkAcknowledgementStatusSchema,
  targetTitle: z.string().optional(),
  assigneeName: z.string().optional(),
  acknowledgedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime().optional(),
});

// ─── #2411 server-boundary variants ─────────────────────────────────────────
// The mobile app parses the permissive base above; the acknowledgement routes
// serialise through these Strict forms.

export const ToolboxTalkAcknowledgementStrict =
  ToolboxTalkAcknowledgementSchema.strict();

export const ToolboxTalkAcknowledgementsResponseStrict = z
  .object({
    acknowledgements: z.array(ToolboxTalkAcknowledgementStrict),
  })
  .strict();

export const ToolboxTalkAcknowledgementResponseStrict = z
  .object({
    acknowledgement: ToolboxTalkAcknowledgementStrict,
  })
  .strict();

export type ToolboxTalkAcknowledgement = z.infer<
  typeof ToolboxTalkAcknowledgementSchema
>;

export const ToolboxTalkAcknowledgementsResponse = z
  .object({
    acknowledgements: z.array(ToolboxTalkAcknowledgementSchema),
  })
  .strict();

export type ToolboxTalkAcknowledgementsResponse = z.infer<
  typeof ToolboxTalkAcknowledgementsResponse
>;

export const ToolboxTalkAcknowledgementResponse = z
  .object({
    acknowledgement: ToolboxTalkAcknowledgementSchema,
  })
  .strict();

export type ToolboxTalkAcknowledgementResponse = z.infer<
  typeof ToolboxTalkAcknowledgementResponse
>;
